// @flow

import { graphql } from 'react-relay';
import { PageMeta } from '../shared/prismic/PageMeta';
import { type NextQuery, nextQuery } from '../controls/relay';
import { DescriptorStore } from '../controls/router';
import { MuiThemeProvider } from '../controls/mui-providers';
import { Layout } from '../shared/Layout.js';
import {
  Developments,
  developmentsFiltersDescriptor,
  ITEMS_PER_PAGE,
} from '../shared/Developments';

import type {
  developmentsQuery,
  developmentsQueryVariables,
} from './__generated__/developmentsQuery.graphql';

const DevelopmentsPage = props => {
  return (
    <Layout
      root={props.data}
      headerStyle="transparent-light"
      pageWithData={props.data.cms.pageWithData}
    >
      <MuiThemeProvider>
        <PageMeta root={props.data} />
        <DescriptorStore>
          <Developments root={props.data} />
        </DescriptorStore>
      </MuiThemeProvider>
    </Layout>
  );
};

const paramsToVariables = (params, query): developmentsQueryVariables => {
  return {
    sortBy: params.sortBy,
    sortDirection: params.sortDirection,
    page: {
      number: params.page ?? 0,
      count: ITEMS_PER_PAGE,
    },
    filters: {
      properties_state_in:
        params.location != null && params.location !== 'all'
          ? [params.location]
          : null,
    },
    uid: query.uid,
    lang: query.lang,
  };
};

const DevelopmentsP: NextQuery<
  // relay query
  developmentsQuery,
  // url query
  {| uid: string, lang: string |},
> = nextQuery(ctx => ({
  query: graphql`
    query developmentsQuery(
      $sortBy: String
      $sortDirection: String
      $page: DevelopmentProductFiltersPage
      $filters: DevelopmentProductFilters
      $uid: String!
      $lang: String!
    ) {
      ...Layout_root @arguments(lang: $lang)
      ...Developments_root
      ...PageMeta_root

      cms {
        pageWithData(uid: $uid, lang: $lang) {
          ...Layout_pageWithData
        }
      }
    }
  `,
  variables: paramsToVariables(
    developmentsFiltersDescriptor.getState(ctx.query),
    ctx.query,
  ),
  cacheStrategy: 'cache-only',
}))(DevelopmentsPage);

export default DevelopmentsP;
